/* IMPORTS
	You can import directly from node_modules here.
*/
import $ from 'jQuery';
// import 'what-input';

/*
	LIBRARY IMPORTS
	Utilities, plugins, and behaviors that aren't tied to a specific component.
*/
// import anchorLinks from './development/libs/anchor-links';
// import linkContainer from './development/libs/link-container';
// import './before-libs/circletype.min.js';
import '../development/before-libs/jquery.fittext.js';
import '../development/before-libs/jquery.youtube-background.min.js';
import '../development/before-libs/lazysizes-config.js';

import '../development/libs/hoverintent.min.js';
import '../development/libs/jpInView.js';
import '../development/libs/jpScrollDirection.js';
import '../development/libs/lazysizes-4.0.0.js';
import '../development/libs/responsive-tables.js';
// Slick is now loaded via CDN in enqueue.php
// import '../development/libs/slick.min.js';
import '../development/libs/smooth-scrolling.js';
import '../development/libs/smoothscroll-polyfill.min.js';
import '../development/libs/webfontloader-1.6.28.js';


/*
  Global Imports
 */
import '../development/after-libs/accessibility.js';
import '../development/after-libs/alerts.js';
import '../development/after-libs/filters.js';
import '../development/after-libs/global.js';
import '../development/after-libs/header-functions.js';
import '../development/after-libs/jquery.fitvids.js';
import '../development/after-libs/lazyload-manual.js';
import '../development/after-libs/main-menu.js';
// import './after-libs/web-font-loader.js';

/*
	Block IMPORTS
	For specific components.
*/
import '../../blocks/accordion-block/js/accordion-block.js';
import '../../blocks/area-showcase/js/area-showcase.js';
import '../../blocks/content-reference/js/content-reference.js';
import '../../blocks/hubspot-block/js/hubspot-block.js';
import '../../blocks/life-cycle-block/js/life-cycle-block.js';
import '../../blocks/logos-block/js/logos-block.js';
import '../../blocks/quote-slider/js/quote-slider.js';
import textImageList from '../../blocks/text-image-list/js/text-image-list.js';
import '../../blocks/wysiwyg-block/js/wysiwyg-block.js';

// Easy console access to jQuery through '$'
window.$ = $;

/* INITIALIZATION */
$(() => {
	$('body').addClass('document-ready');
});

$(document).ready(function() {
	/* Higher priority first, lower priority later */
	textImageList();
});

// FOUC on-fully-loaded make the page visible:
addEventListener('load', (e) => {
	document.documentElement.style.visibility = 'visible';
});
